// import { default as scroll } from '../base/_scroll';

let timeline_elements = null;
let timeline_filters = null;

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

// Polyfill for closest
if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}


const init = function() {

	timeline_filters = document.querySelectorAll('.js-timeline-filter');
	timeline_elements = document.querySelectorAll('#timeline li');

	if ( typeof timeline_filters === 'undefined' ) {
		return;
	}

	Array.prototype.forEach.call( timeline_filters, function( element ) {

		const filter_by = element.getAttribute('data-filter');

		element.addEventListener( 'click', ( event ) => {

			deselectAllFilters();

			element.closest('li').classList.add('selected');

			// user clicked "all"
			if ( !filter_by ) {

				showTimeLineItems(false);
				showTimeLineItems(true);
				restaggerTimeline();

			// user clicked one of the category filters
			} else {

				showTimeLineItems(false);

				// loop through timeline items and show those corresponding to filter
				Array.prototype.forEach.call( timeline_elements, function( element ) {

					const element_categories = element.getAttribute('data-timeline-category');

					if ( element_categories && element_categories.length >= 0 ) {
						if ( element_categories.indexOf( filter_by ) >= 0 ) {
							element.style.display = 'block';
						}
						restaggerTimeline();
					}

				});

			}

			event.preventDefault();

		});

	});

}


/**
 *
 *
 *
 */
const restaggerTimeline = function() {

	const evenClass = 'timeline-item--is-even';
	let counter = 0;

	Array.prototype.forEach.call( timeline_elements, function( element ) {
		element.classList.remove(evenClass);
	});

	Array.prototype.forEach.call( timeline_elements, function( element ) {
		if ( element.style.display === 'block' ) {
			if ( counter % 2 ) {
				element.classList.add(evenClass);
			}
			counter++;
		}
	});

}


/**
 *
 *
 */
const showTimeLineItems = function( status ) {

	if ( status ) {

		Array.prototype.forEach.call( timeline_elements, function( element ) {
			element.style.display = 'block';
		});

	} else {

		Array.prototype.forEach.call( timeline_elements, function( element ) {
			element.style.display = 'none';
			element.classList.remove('animated');
			element.classList.remove('fadeInUp');
		});

	}

}


/**
 *
 *
 *
 */
const deselectAllFilters = function() {

	Array.prototype.forEach.call( timeline_filters, function( element ) {
		element.closest('li').classList.remove('selected');
	});

};


const api = {
	init: init
};

export default api;